import React from "react";

function AttentionBanner(props) {
  const { attentionBanner, svgObjects } = props;

  return (
    <>
      {attentionBanner?.housing_archive_attention_banner && (
        <div className="tampuuri-properties--attention-banner">
          <div className="element-block--wider">
            <div className="banner-content">
              {attentionBanner?.options?.icon && (
                <div className="icon">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: attentionBanner?.options?.icon,
                    }}
                  />
                </div>
              )}

              {attentionBanner?.options?.attention_banner_title && (
                <span className="title">
                  {attentionBanner?.options?.attention_banner_title}
                </span>
              )}

              {attentionBanner?.options?.attention_banner_text && (
                <span className="text">
                  {attentionBanner?.options?.attention_banner_text}
                </span>
              )}

              {attentionBanner?.options?.attention_banner_cta?.url && (
                <a
                  className="button"
                  href={attentionBanner?.options?.attention_banner_cta?.url}
                  target={
                    attentionBanner?.options?.attention_banner_cta?.target
                  }
                >
                  <div
                    className="d-flex flex-wrap align-center"
                    dangerouslySetInnerHTML={{
                      __html: svgObjects?.location,
                    }}
                  />
                  <div className="icon-text">
                    {attentionBanner?.options?.attention_banner_cta?.title}
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AttentionBanner;
